import { createStore, applyMiddleware, compose } from 'redux';
import { createRequestMiddleware } from 'redux-requests';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import { config } from 'src/constants';

import reducer from './reducers';

const INITIAL_STATE = {
  domain: {
    notifications: [],
    isLoaderVisible: false
  },
  requests: {}
};

function configureStore(middlewares = [], initialState = INITIAL_STATE) {
  const composeEnhancer = config.isDevEnv ? composeWithDevTools : compose;
  const store = createStore(
    reducer,
    initialState,
    composeEnhancer(
      applyMiddleware(thunk, createRequestMiddleware(), ...middlewares)
    )
  );

  return {
    store,
    Provider
  };
}

export default configureStore;
